module.exports = __webpack_public_path__ + "static/media/rogue4_preview.03930cb2.jpg";